import type { ApiConfig } from '../../types'

// Aster APIは最大7日間の範囲で取得可能
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000

export const tradeHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1000,
  order: 'asc', // 古い順に取得
  range: SEVEN_DAYS_MS, // 7日間ごとに区切って取得
  requiresRange: true,
  type: 'trade-history',
} as const satisfies ApiConfig
